import React from 'react';
import { Language, Social } from '../../components';
import styles from './static.module.css';
import { useLocation } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';
import { useIntl } from 'react-intl';

const Static = () => {
  const [width, height] = useWindowSize();
  const [vertical, setVertical] = React.useState(false);
  const location = useLocation();
  const intl = useIntl();

  React.useEffect(() => {
    if (width < height) {
      setVertical(true);
    } else {
      setVertical(false);
    }
  });

  return (
    <>
      {vertical && (
        <div className={styles.vertical}>
          <div className={styles.vertical_text}>
            <div>{intl.formatMessage({ id: 'rotation.title-top' })}</div>
            <div>{intl.formatMessage({ id: 'rotation.title-bottom' })}</div>
          </div>
          <img src="/images/Recurso 1.svg" alt="" className={styles.icon} />
        </div>
      )}
      <div className={styles.container}>
        {location.pathname !== '/' && (
          <Language
            changeColor={location.pathname === '/chapters' ? false : true}
            style={{
              bottom:
                location.pathname !== '/' && location.pathname !== '/chapters'
                  ? 100
                  : '',
            }}
          />
        )}
        {(location.pathname === '/' || location.pathname === '/chapters') && (
          <Social />
        )}
      </div>
    </>
  );
};

export default Static;
